import { partial } from 'ramda';

import { ThreadVariant } from '../../Cockpit.types.ts';
import { RouteId, RouteIdPart } from '~/routes/RouteId.ts';

export const variantRouteMapping: Record<ThreadVariant, (id: string, initialMessage?: string) => string> = {
  [ThreadVariant.CONVERSATION]: RouteId.cockpitConversation,
  [ThreadVariant.GUIDED]: RouteId.cockpitGuided,
  // This might need refactoring once more additional variants are added
  [ThreadVariant.SOURCING]: partial(RouteId.cockpitConversationEntity, [RouteIdPart.demand]),
};
